var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Webview',[_c('div',{staticClass:"_fill"},[(_vm.ready)?_c('router-view'):_vm._e(),(_vm.error)?_c('ResultPage',[_c('div',[_vm._v(" 網路異常"),_c('br'),_vm._v(" 請重新再試 ")])]):_vm._e()],1),_c('PageTab')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }